import {Component, computed, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MatDialog} from '@angular/material/dialog'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {UcDecisionPipe} from '../../../pipes/uc-decision.pipe'
import {LoanService} from '../../../services/loan.service'
import {RoleHelper} from '../../../services/role-helper'
import {KalpItemComponent} from '../kalp-item/kalp-item.component'
import {UcReportComponent} from '../uc-report/uc-report.component'

@Component({
  selector: 'spb-kalp-uc-info',
  templateUrl: './uc-info.component.html',
  styleUrls: ['../kalp.component.scss'],
  imports: [MatButton, KalpItemComponent, UcDecisionPipe]
})
export class UcInfoComponent {
  public readonly loanService = inject(LoanService)
  public isUcAvailable = computed(() => {
    const app = this.loanService.application()
    return app ? !app.applicants.some(a => !a.uc) : true
  })
  public readonly configService = inject(ConfigService)
  public readonly helper = inject(RoleHelper)

  private readonly dialog = inject(MatDialog)

  public getReport(sub: string) {
    this.loanService.getHtml(sub).subscribe(html => {
      this.dialog.open(UcReportComponent, {
        data: html.html,
        minWidth: '98%'
      })
    })
  }
}
